import * as React from 'react';
import { cn } from '@companion-professional/webutils';

// DialogFooter is the footer section of the Dialog.  This can contain the <DialogClose /> component which allows for
// an easy way to close the dialog.
export const DialogFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col-reverse gap-2 sm:flex-row sm:justify-end', className)} {...props} />
);
DialogFooter.displayName = 'DialogFooter';
